module.exports = __webpack_public_path__ + "img/report.2ea03e68.png";